import React from 'react';
import { AiOutlineFileText } from 'react-icons/ai';
import { BsInfoCircleFill } from 'react-icons/bs';
import { FaDev } from 'react-icons/fa';
import { FiMap, FiMapPin } from 'react-icons/fi';
import { RiContactsBookLine, RiRegisteredLine } from 'react-icons/ri';
import { VscVersions } from 'react-icons/vsc';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import logoItm from '../../../ressources/logoitm.png';
import * as s from '../../../ressources/StyleGlobal/StyleGlobal';
import styles from './Info.module.scss';

const Info = () => {
  // Helper function for opening PDFs
  const openPdf = (pdfPath) => {
    window.open(pdfPath);
  };

  return (
    <div className={[styles.molder, s.row].join(' ')}>
      <div className={styles.title}>
        <BsInfoCircleFill size={40} color={'#EEB214'} /> {checkMot('info')}{' '}
      </div>
      <div className={[styles.img, s.row].join(' ')}>
        <div className={[s.col_4, styles.paD].join(' ')}>
          <div className={styles.subtitle}>
            <RiRegisteredLine size={25} color={'#a6163f'} />{' '}
            {checkMot('itmsol_monitoring_software')}{' '}
          </div>
          <div className={styles.subtitle_T}>
            <VscVersions size={25} color={'#a6163f'} /> {checkMot('argos')}
          </div>

          <div className={styles.subtitle_A}>
            <FiMapPin size={25} color={'#a6163f'} />{' '}
            {checkMot("3 rue de l'arrivée")}
          </div>
          <div className={styles.subtitle_N}>
            <FiMap size={25} color={'#a6163f'} /> {checkMot('75015, Paris')}
          </div>
          <div className={styles.subtitle_A}>
            <RiContactsBookLine size={25} color={'#a6163f'} />{' '}
            {checkMot('Contact : ')}
            <a className={styles.lin} href="https://itmsol.fr/contact">
              {checkMot('contact@itmsol.fr')}
            </a>
          </div>

          <div className={styles.dev}>
            <FaDev size={25} color={'#a6163f'} /> {checkMot('Développement :')}{' '}
          </div>
          <img alt="logo" src={logoItm} className={styles.logoItm} />
        </div>
        <div
          className={[
            s.card,
            s.col_8,
            s.text_left,
            styles.perso,
            s.overflow_auto,
          ].join(' ')}
        >
          <div className={s.card_body}>
            <h5 className={s.card_title}>
              Itmsol Monitoring Software ARGOS Monitoring Software V19
            </h5>

            <div className={[s.card_text, s.text_justify].join(' ')}>
              {/* ...existing legal text content... */}
            </div>
            <button
              type="button"
              className={[s.btn, styles.space, s.btn_primary].join(' ')}
              onClick={() =>
                openPdf('pdf/Argos Monitoring Software V19 - License.pdf')
              }
            >
              <AiOutlineFileText size={20} color={'#fffff'} />{' '}
              <span>{checkMot('mentions_legales_pdf')} </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Info;
